"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tabs = Tabs;

var _react = _interopRequireWildcard(require("react"));

var _tabs = _interopRequireDefault(require("govuk-frontend/govuk/components/tabs/tabs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Tabs(props) {
  var className = props.className,
      id = props.id,
      idPrefix = props.idPrefix,
      items = props.items,
      title = props.title,
      attributes = _objectWithoutProperties(props, ["className", "id", "idPrefix", "items", "title"]);

  var tabsRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    new _tabs["default"](tabsRef.current).init();
  }, [tabsRef]);
  var tabContent = items.map(function (item, index) {
    // eslint-disable-next-line no-unused-vars
    var itemId = item.id,
        label = item.label,
        panel = item.panel,
        itemAttributes = _objectWithoutProperties(item, ["id", "label", "panel"]);

    return /*#__PURE__*/_react["default"].createElement("li", {
      key: itemId,
      className: "govuk-tabs__list-item".concat(index === 0 ? ' govuk-tabs__list-item--selected' : '')
    }, /*#__PURE__*/_react["default"].createElement("a", _extends({
      className: "govuk-tabs__tab",
      href: "#".concat(itemId || "".concat(idPrefix, "-").concat(index))
    }, itemAttributes), label));
  });

  var tabs = /*#__PURE__*/_react["default"].createElement("ul", {
    className: "govuk-tabs__list"
  }, tabContent);

  var panels = items.map(function (item, index) {
    // eslint-disable-next-line no-unused-vars
    var itemId = item.id,
        panel = item.panel,
        label = item.label,
        itemAttributes = _objectWithoutProperties(item, ["id", "panel", "label"]);

    return /*#__PURE__*/_react["default"].createElement("div", _extends({
      key: itemId,
      className: "govuk-tabs__panel".concat(index > 0 ? ' govuk-tabs__panel--hidden' : ''),
      id: itemId
    }, itemAttributes), panel.children);
  });
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    id: id,
    className: "govuk-tabs ".concat(className || '')
  }, attributes, {
    "data-module": "govuk-tabs",
    ref: tabsRef
  }), /*#__PURE__*/_react["default"].createElement("h2", {
    className: "govuk-tabs__title"
  }, title), tabs, panels);
}

Tabs.defaultProps = {
  title: 'Contents'
};